import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IconsModule} from '../../components/kit/icons/icons.module';
import {JsonSchemaRendererModule} from '../../components/renderer/json-schema-renderer.modul';
import {NgModule} from '@angular/core';
import {ProjectListComponent} from './list/project-list.component';
import {SharedModule} from 'src/app/shared.module';
import {WidgetsComponentsModule} from 'src/app/components/kit/widgets/widgets-components.module';
import {ElementsModule} from '../../components/elements/elements.module';
import {ProjectsRoutingModule} from './projects-routing.module';
import { ProjectCreateComponent } from './create/project-create.component';
import { ProjectEditComponent } from './edit/project-edit.component';
import { ProjectRolesModule } from '@app/components/project-roles/project-roles.module';

const COMPONENTS = [
	ProjectListComponent,
];

@NgModule({
	imports: [
		FormsModule,
		IconsModule,
		JsonSchemaRendererModule,
		ReactiveFormsModule,
		SharedModule,
		ProjectsRoutingModule,
		WidgetsComponentsModule,
		ElementsModule,
		ProjectRolesModule,
	],
	declarations: [...COMPONENTS, ProjectCreateComponent, ProjectEditComponent]
})
export class ProjectsModule {}
